// packages import
import { Box, Button } from '@mui/material'
import { FC, useContext } from 'react'
import { useNavigate } from 'react-router-dom'

// component import
import { ContentHead } from '../../../components/common/ContentHead'
import { EmptyData } from '../../../components/common/EmptyData'
import { FundRequestsListing } from '../../../components/billing/fundRequests/FundRequestsListing'
import FundRequestsFilters from '../../../components/billing/fundRequests/filters'

// others
import { CardBox } from '../../../theme/styleComponents'
import { flexCenter } from '../../../theme/styleConstants'
import { FundRequestsContext } from '../../../context/FundRequestsContext'
import { AuthContext } from '../../../context'
import { hasAdminAccess } from '../../../utils'

export const FundRequests: FC = (): JSX.Element => {
  const { loading, refetch, fundRequests } = useContext(FundRequestsContext)
  const navigate = useNavigate()
  const { currentUser } = useContext(AuthContext)

  const isEmpty = !loading && fundRequests.length === 0
  const hasAdminRights = hasAdminAccess(currentUser)

  const handleGenerateFundRequests = () => {
    navigate('/billing/generate-fund-requests')
  }

  const renderActionButtons = () => (
    <Box display="flex" gap={2} alignItems="center">
      <Button variant="contained" onClick={handleGenerateFundRequests}>
        Generate Fund Requests
      </Button>
    </Box>
  )

  return (
    <>
      <CardBox marginTop={3}>
        <ContentHead title="Fund Requests" customButton={hasAdminRights ? renderActionButtons : undefined} />

        <FundRequestsFilters />

        {isEmpty ? (
          <Box sx={{ ...flexCenter, height: 'calc(100vh - 400px)' }}>
            <EmptyData title="No fund requests found" />
          </Box>
        ) : (
          <FundRequestsListing fundRequests={fundRequests} loading={loading} refetch={refetch} />
        )}
      </CardBox>
    </>
  )
}

export default FundRequests
